import React from 'react';
import logoBlack from '../../../assets/logo-noir.png';

import CONFIG from '../../../config';
import WidgetInputText from '../../../components/widgets/WidgetInputText';

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Base64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';


function NouveauMdp() {
  const navigate = useNavigate();

  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            navigate("/client/dossier");
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  const [done, setDone] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [motDePasse, setMotDePasse] = React.useState(null);
  const [motDeDasseBis, setMotDeDasseBis] = React.useState(null);
  const [newPasswordValid, setNewPassword] = React.useState(false);
  const formNewPassword = [[motDePasse, setMotDePasse], [motDeDasseBis, setMotDeDasseBis]];

  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get("code");


  React.useEffect(() => {
    setNewPassword(false);

    if (motDePasse !== null && motDeDasseBis !== null) {
      if (motDePasse.value !== motDeDasseBis.value) {
        if (!motDeDasseBis.error)
          setMotDeDasseBis((s) => ({ ...s, error: true, errorMessage: "Le mot de passe est différent" }));
      } else {
        if (motDeDasseBis.error)
          setMotDeDasseBis((s) => ({ ...s, error: false, errorMessage: null }));
      }
    }

    if (motDePasse === null || motDePasse.value === '')
      return;

    if (motDeDasseBis === null || motDeDasseBis.value === '')
      return;

    setNewPassword(true);
  }, formNewPassword.map((x) => x[0]));


  const submitFormNewPassword = () => {
    let payload = {};

    if (motDePasse !== null && motDeDasseBis !== null) {
      payload['mot_de_passe'] = Base64.stringify(sha256(motDePasse.value));
    }

    axios.post(CONFIG.API_URL + '/api/new_password/' + code, payload)
      .then((response) => {
        switch (response.status) {
          case 200:
            setDone(true);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 404:
            setError(true);
            break;

          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };


  return (
    <>
      <div className='m-6 grid-cols-12 gap-x-4 shrink-0 p-6 max-w-lg mx-auto bg-white my-shadow'>
        <div className='col-start-3 col-span-8 w-full item-center mb-6'>
          <img src={logoBlack} alt="Logo" />
        </div>

        <div className='col-span-12 w-full mb-2 text-center'>
          <h1>Changement de mot de passe</h1>
        </div>

        <div className='col-start-2 col-span-10 w-full mb-6 text-center'>
          Renseignez votre nouveau mot de passe.
        </div>

        <div className='col-start-2 col-span-10 w-full mb-4'>
          <WidgetInputText state={motDePasse} setState={setMotDePasse} id={'mot_de_passe'} text={"Nouveau mot de passe"} type={'password'} regex={/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(.{8,})$/} regex_helper={"Votre email doit comporter au moins : une minuscule, une majuscule, un chiffre, et 8 caractères"} />
        </div>

        <div className='col-start-2 col-span-10 w-full mb-4'>
          <WidgetInputText state={motDeDasseBis} setState={setMotDeDasseBis} id={'mot_de_passe_bis'} text={"Confirmez le mot de passe"} type={'password'} />
        </div>

        {done &&
          <div className='col-start-2 col-span-10 w-full mb-4 text-center text-sm bg-green-200 rounded-md p-2'>
            Votre mot de passe a été changé, vous pouvez <Link variant='contained' href={CONFIG.BASE_URL + "/connexion"}><span className='text-black underline decoration-black hover:decoration-2'>cliquer ici</span></Link> pour vous connecter.
          </div>
        }

        {error &&
          <div className='col-start-2 col-span-10 w-full mb-4 text-center text-sm bg-red-200 rounded-md p-2'>
            Ce lien est erroné ou expiré, vous pouvez <Link variant='contained' href={CONFIG.BASE_URL + "/mdp_oublie"}><span className='text-black underline decoration-black hover:decoration-2'>cliquer ici</span></Link> pour en recevoir un nouveau.
          </div>
        }

        <div className='col-start-7 col-span-5 w-full text-right'>
          <Button variant='contained' disabled={!newPasswordValid} onClick={submitFormNewPassword}>
            Envoyer
          </Button>
        </div>
      </div>
    </>
  );
}

export default NouveauMdp;